'use strict';

var b2cApp = angular.module('b2cApp', [
    'b2cApp.controllers',
    'b2cApp.services',
    'ngCookies',
    'ngResource',
    'ui.bootstrap',
    'ngMessages',
    'boxuk.translation',
    'ngSanitize',
    'sdFaq',
    'ui.bootstrap.collapse' // ? FAQ
]);

angular.module('b2cApp.controllers', []);
angular.module('b2cApp.services', ['ngResource']);
angular.module('b2cApp.directives', []);
angular.module('b2cApp.validators', []);

b2cApp
    .config(function ($interpolateProvider, $compileProvider) {
        $interpolateProvider.startSymbol('[[');
        $interpolateProvider.endSymbol(']]');

        if ("dev" !== 'dev') {
            $compileProvider.debugInfoEnabled(false);
        }
    });

require('../libraries/angular-symfony-translation/angular-symfony-translation.min.js');
// todo: select only used templates
require('../libraries/ui-bootstrap/ui-bootstrap-tpls-2.5.0.js');
require('../libraries/ng-cookies/angular-cookies.js');
require('../libraries/skydreams/faq/sd-faq.js');

require('./controllers/redirect-controller.js');
require('./controllers/result-controller.js');
require('./controllers/review-controller.js');
require('./review-service');
require('./project-budget-service');
